import { useEffect, useState } from 'react';
import { delayTaskParameters } from '../../../shared/consts/table';
import ButtonComponent from '../../../components/button/button';
import AccessibilityControls from '../../../components/accessibilty/accessibility-controls';
import { useNavigate } from 'react-router-dom';
import { useUserData } from '../../../shared/context/user-data-context';
import './styles.css';
import { postSearchResults } from '../../../features/search/service/search-service';
import { IDelayQuestions } from '../../../shared/types/questions';
import { createObjectQuestions } from '../../../shared/helpers/object-questions.helper';
import { useAuthUser } from '../../../shared/hooks/use-auth-user';
import { getConfigurationsTestsByCompanyId } from '../../../features/search/service/config-tests';
import { User } from '../../../shared/types/user';
import { ConfigsTests } from '../../../shared/types/configs-tests';
import { useAccessibility } from '../../../shared/context/a11y-context';
import { getMe } from '../../../features/search/service/user-service';
import { ProjectLoader } from '../../../components/project-loader/project-loader';

const DDCurtoQuestions = () => {
  const [round, setRound] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(16);
  const [stepSize, setStepSize] = useState(8);
  const [choices, setChoices] = useState<any[]>([]);
  const [isComplete, setIsComplete] = useState(false);
  const [time, setTime] = useState<number[]>([]);
  const [questionStartTime, setQuestionStartTime] = useState<number>(0);
  const [testStartTime, setTestStartTime] = useState<string>('');
  const [buttonOrder, setButtonOrder] = useState<'immediate-first' | 'delayed-first'>('immediate-first');
  const [fontSizeLevel, setFontSizeLevel] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const [configsTests, setConfigsTests] = useState<ConfigsTests[]>([]);
  const [configsLoading, setConfigsLoading] = useState(true);
  const [me, setMe] = useState<User | null>(null);

  const [highlightedChoice, setHighlightedChoice] = useState<'immediate' | 'delayed' | null>(null); // ✅ NOVO

  const { userData } = useUserData();
  const { user, loading: userLoading, error: userError } = useAuthUser();
  const { screenReaderEnabled, announceMessage } = useAccessibility();
  const navigate = useNavigate();

  const handleFontSizeChange = (level: number) => {
    setFontSizeLevel(level);
  };

  const handleChoice = (choice: 'immediate' | 'delayed') => {
    const currentTime = new Date().getTime();
    const elapsedTime = (currentTime - questionStartTime) / 1000;

    setSlideDirection(choice === 'immediate' ? 'left' : 'right');
    setIsTransitioning(true);

    setTimeout(() => {
      setTime(prevTime => [...prevTime, elapsedTime]);

      if (choice === 'immediate') {
        setCurrentIndex(currentIndex - stepSize);
      } else {
        setCurrentIndex(currentIndex + stepSize);
      }
      
      setRound(round + 1);
      setStepSize(stepSize / 2);

      setChoices(prevChoices => [
        ...prevChoices,
        { 
          round, 
          choice, 
          elapsedTime,
          currentIndex,
        }
      ]);
      
      if (round === 5) {
        setIsComplete(true);
      } else {
        setQuestionStartTime(new Date().getTime());
        setButtonOrder(Math.random() < 0.5 ? 'immediate-first' : 'delayed-first');
      }

      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 400);
  };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const me = await getMe();
                setMe(me);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

  const reset = () => {
    setTime([]);
    setRound(1);
    setCurrentIndex(16);
    setStepSize(8);
    setChoices([]);
    setIsComplete(false);
    setIsTransitioning(false);
    setQuestionStartTime(new Date().getTime());
    setTestStartTime(new Date().toISOString());
    setButtonOrder(Math.random() < 0.5 ? 'immediate-first' : 'delayed-first');
    setHighlightedChoice(null);
    navigate('/home');
  };

  useEffect(() => {
    const now = new Date().toISOString();
    setQuestionStartTime(new Date().getTime());
    setTestStartTime(now);
    setButtonOrder(Math.random() < 0.5 ? 'immediate-first' : 'delayed-first');
  }, []);

  useEffect(() => {
    const fetchConfiguration = async () => {
      try {
        setConfigsLoading(true);
        const userDataT: User = user as User;
        const configs = await getConfigurationsTestsByCompanyId(userDataT.companyId || '');
        setConfigsTests(configs);
      } catch (error) {
        console.error('❌ Erro ao buscar configurações:', error);
      } finally {
        setConfigsLoading(false);
      }
    };
    
    if (user && user.companyId) {
      fetchConfiguration();
    }
  }, [user]);

  useEffect(() => {
    if (isComplete && choices.length > 0 && time.length > 0 && user) {
      const finalItem = delayTaskParameters.find((d) => d.index === choices[4].currentIndex);
      
      let ed50Value;
      let kValue;
      const lastChoice = choices[choices.length - 1];
      
      if (lastChoice.choice === 'immediate') {
        ed50Value = finalItem?.ed50?.immediate || null;
        kValue = finalItem?.k?.immediate || null;
      } else {
        ed50Value = finalItem?.ed50?.delayed || null;
        kValue = finalItem?.k?.delayed || null;
      }

      const completedAt = new Date().toISOString();

      if (!user.companyId) {
        console.error('❌ Erro: Usuário não possui company associada');
        alert('Erro: Usuário não está vinculado a nenhuma empresa.');
        return;
      }

      const resultObject: IDelayQuestions = createObjectQuestions(
        userData, 
        choices, 
        ed50Value, 
        kValue,
        testStartTime,
        completedAt,
        user.companyId,
        me
      );
      
      createSearchResults(resultObject);
    }
  }, [isComplete, choices, time, currentIndex, testStartTime, userData, user]);

  useEffect(() => {
    if (isComplete) {
      const timer = setTimeout(() => {
        reset();
      }, 15000);

      return () => clearTimeout(timer);
    }
  }, [isComplete]);

  const createSearchResults = async (searchResult: IDelayQuestions) => {
    try {
      const response = await postSearchResults(searchResult);
      
      if (response.planUsage.remaining !== 'ilimitado' && response.planUsage.remaining < 5) {
        console.warn(`⚠️ Atenção: Restam apenas ${response.planUsage.remaining} testes neste mês.`);
      }
    } catch (error) {
      console.error('❌ Erro ao criar resultado de pesquisa:', error);
      alert('Erro ao salvar o resultado. Por favor, tente novamente.');
    }
  };

  const currentItem = delayTaskParameters.find((d) => d.index === currentIndex);
  const currentDelayChoice = currentItem?.delayChoice || '3 semanas';

  const imediateButtonLabel = configsTests[0] 
    ? `${configsTests[0].currency} ${configsTests[0].firstValue} agora`
    : 'Carregando...';
    
  const delayedButtonLabel = configsTests[0]
    ? `${configsTests[0].currency} ${configsTests[0].secondValue} em ${currentDelayChoice}`
    : 'Carregando...';

  const getFontSizeClass = () => {
    switch(fontSizeLevel) {
      case 0: return 'font-level-0';
      case 1: return 'font-level-1';
      case 2: return 'font-level-2';
      case 3: return 'font-level-3';
      case 4: return 'font-level-4';
      default: return 'font-level-0';
    }
  };

  useEffect(() => {
    if (!screenReaderEnabled) return;
    if (userLoading || configsLoading) return;
    if (!configsTests[0]) return;
    if (!currentItem) return;

    if (isComplete) {
      setHighlightedChoice(null);
      announceMessage('Teste concluído. Você pode iniciar um novo teste.', 'polite');
      return;
    }

    const currency = configsTests[0].currency;
    const firstValue = configsTests[0].firstValue;
    const secondValue = configsTests[0].secondValue;

    const immediatePhrase = `${currency} ${firstValue} agora`;
    const delayedPhrase = `${currency} ${secondValue} em ${currentDelayChoice}`;

    if (typeof window === 'undefined' || !('speechSynthesis' in window)) {
      const baseText = buttonOrder === 'immediate-first'
        ? `Pergunta de escolha. Você prefere ganhar ${immediatePhrase} ou ${delayedPhrase}?`
        : `Pergunta de escolha. Você prefere ganhar ${delayedPhrase} ou ${immediatePhrase}?`;

      announceMessage(baseText, 'assertive');
      return;
    }

    const synth = window.speechSynthesis;
    synth.cancel();
    setHighlightedChoice(null);

    const utterances: SpeechSynthesisUtterance[] = [];

    const addUtterance = (
      text: string,
      onStart?: () => void,
      onEnd?: () => void
    ) => {
      const u = new SpeechSynthesisUtterance(text);
      u.lang = 'pt-BR';
      if (onStart) u.onstart = onStart;
      if (onEnd) u.onend = onEnd;
      utterances.push(u);
    };

    addUtterance('Você prefere ganhar');

    if (buttonOrder === 'immediate-first') {
      addUtterance(
        immediatePhrase,
        () => setHighlightedChoice('immediate'),
        () => setHighlightedChoice(null)
      );
      addUtterance('ou');
      addUtterance(
        delayedPhrase,
        () => setHighlightedChoice('delayed'),
        () => setHighlightedChoice(null)
      );
    } else {
      addUtterance(
        delayedPhrase,
        () => setHighlightedChoice('delayed'),
        () => setHighlightedChoice(null)
      );
      addUtterance('ou');
      addUtterance(
        immediatePhrase,
        () => setHighlightedChoice('immediate'),
        () => setHighlightedChoice(null)
      );
    }

    utterances.forEach(u => synth.speak(u));

    return () => {
      synth.cancel();
      setHighlightedChoice(null);
    };
  }, [
    screenReaderEnabled,
    userLoading,
    configsLoading,
    configsTests,
    currentItem,
    currentDelayChoice,
    buttonOrder,
    isComplete,
    announceMessage,
  ]);

  if (userLoading || configsLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <ProjectLoader label="Carregando configurações" />
      </div>
    );
  }

  if (userError || !user || !user.companyId || !configsTests[0]) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        gap: '20px',
        padding: '20px'
      }}>
        <p style={{ fontSize: '1.2rem', color: '#d32f2f', textAlign: 'center' }}>
          ❌ Erro: {userError || !configsTests[0] 
            ? 'Não foi possível carregar as configurações do teste.' 
            : 'Usuário não está vinculado a uma empresa.'}
        </p>
        <ButtonComponent label="Voltar" onClick={() => navigate('/')} />
      </div>
    );
  }

  if (isComplete) {
    let indexAfter4thRound = 16;
    let currentStepSize = 8;
    
    for (let i = 0; i < 4; i++) {
      if (choices[i].choice === 'immediate') {
        indexAfter4thRound -= currentStepSize;
      } else {
        indexAfter4thRound += currentStepSize;
      }
      currentStepSize = currentStepSize / 2;
    }
    
    const fourthRoundItem = delayTaskParameters.find((d) => d.index === indexAfter4thRound);
    const fifthChoice = choices[4];

    let calculatedED50;
    if (fourthRoundItem && fifthChoice) {
      calculatedED50 = fifthChoice.choice === 'immediate' 
        ? fourthRoundItem.ed50?.immediate 
        : fourthRoundItem.ed50?.delayed;
    }

    return (
      <>
        <AccessibilityControls onFontSizeChange={handleFontSizeChange} />
        <div className={`question-conclude ${getFontSizeClass()}`}>
          <div className="question-result">
            <div
              className={`thanks-container ${getFontSizeClass()}`}
              data-main-content
            >
              <p>Muito obrigado por participar da atividade! Sua ajuda é muito importante.</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  const immediateButton = (
    <ButtonComponent 
      label={imediateButtonLabel}
      onClick={() => handleChoice('immediate')}
      disabled={isTransitioning || userLoading || configsLoading}
      isHighlighted={highlightedChoice === 'immediate'} // ✅ DESTACA
    />
  );

  const delayedButton = (
    <ButtonComponent 
      label={delayedButtonLabel}
      onClick={() => handleChoice('delayed')}
      disabled={isTransitioning || userLoading || configsLoading}
      isHighlighted={highlightedChoice === 'delayed'} // ✅ DESTACA
    />
  );

  const separator = (
    <div style={{ marginTop: '20px' }}>
      <p style={{ fontSize: '1.5rem', fontWeight: 'bold', fontFamily: 'Roboto', padding: '20px' }}>ou</p>
    </div>
  );

  return (
    <>
      <AccessibilityControls onFontSizeChange={handleFontSizeChange} />
      <div className={`question-container ${getFontSizeClass()}`}>
        <div 
          className={`question ${isTransitioning ? `slide-out-${slideDirection}` : 'slide-in'}`}
        >
          <div className="question-text">Você prefere ganhar?</div>
          
          <div className="question-buttons">
            {buttonOrder === 'immediate-first' ? (
              <>
                {immediateButton}
                {separator}
                {delayedButton}
              </>
            ) : (
              <>
                {delayedButton}
                {separator}
                {immediateButton}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DDCurtoQuestions;
